/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DataSourcePrioritiesPageEntrypointProps } from './DataSourcePrioritiesPage.entrypoint.types.tsx';

type DataSourcePrioritiesEntryPointComponent = EntryPointComponent<
	{},
	{},
	DataSourcePrioritiesPageEntrypointProps,
	{}
>;

export const dataSourcePrioritiesEntryPoint: EntryPoint<
	DataSourcePrioritiesEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<DataSourcePrioritiesEntryPointComponent>(
		/* webpackChunkName: "async-data-source-priorities" */ './DataSourcePrioritiesPage.tsx',
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
